import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../../widgets/widgets.module';
import { ContactProfileComponent } from './contact-profile/contact-profile.component';
import { ContactActivityComponent } from './contact-activity/contact-activity.component';
import { ContactRelationshipComponent } from './contact-relationship/contact-relationship.component';
import { ContactNoteComponent } from './contact-note/contact-note.component';
import { ContactInformationComponent } from './contact-information/contact-information.component';
import { ContactInformationItemComponent } from './contact-information-item/contact-information-item.component';
import { ContactDetailTemplateComponent } from './contact-detail-template.component';
import { ContactPanelActivityModule } from '../../contact-panel/contact-panel-activity/contact-panel-activity.module';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        ContactPanelActivityModule
    ],
    declarations: [
        ContactActivityComponent,
        ContactRelationshipComponent,
        ContactNoteComponent,
        ContactInformationComponent,
        ContactInformationItemComponent,
        ContactDetailTemplateComponent,
    ],
    exports: [
        ContactActivityComponent,
        ContactRelationshipComponent,
        ContactNoteComponent,
        ContactInformationComponent,
        ContactInformationItemComponent,
        ContactDetailTemplateComponent,
    ]
})
export class ContactDetailTemplateModule { }
